import React, {useCallback, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
import Divider from '@mui/joy/Divider';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Autocomplete from '@mui/joy/Autocomplete';
import Textarea from '@mui/joy/Textarea';
import Checkbox from '@mui/joy/Checkbox';
import Typography from '@mui/joy/Typography';
import Table from '@mui/joy/Table';
import FormHelperText from '@mui/joy/FormHelperText';
import { NumericFormat } from 'react-number-format';
import Loading from "../../components/loading";
import { toast } from 'react-toastify';
//SERVICES  
import AccountSeervice from "../../services/accountService";
import ListService from "../../services/listService";
import ExchangeOperationService from "../../services/exchangeOperationService";


function OperationsMoney() {

    const initPreview = {
        exchange_type_id: 1,
        comitente: '',
        codComitente: '',
        comitenteDesc: '',
        operationType: '',
        // origen: '',
        // destino: '',
        quantity: '',
        pricetype: 2,
        currency: '',
        base: '',
        esco: '',
        spread: '',
        observations: '',
        accountManager: '',
        contraparte: '',
        segment: '',
        term: '',
        is_usd_for_intermediation: false,
    }
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(true)
    const [listAccounts, setListAccounts] = useState([])
    const [previewModel, setPreviewModel] = useState(initPreview)
    const [listSegments, setListSegments] = useState([])
    const [listTerms, setListTerms] = useState([])
    const [listPorfolio, setListPortfolio] = useState([])
    const [listOpeType, setListOpeType] = useState([])
  
    useEffect(() => {
        if(cargando){ doLoad() }
    }, []);


    const doLoad = useCallback(
        async (event) => {
            try {  
                // Comitentes
                const responseAccount = await AccountSeervice.getAccountAutocomplete()
                setListAccounts(responseAccount.data)  
                // Segments
                const responseSegments = await ListService.getSegmentList()
                const temSegments = []
                responseSegments.data.forEach( function(item, key) {
                    if(item.id != 3){ temSegments.push({id: item.id , name: item.name}) }
                });
                setListSegments(temSegments)
                // Terms
                const responseTerms = await ListService.getTermList()
                const tempTerms = []
                responseTerms.data.forEach( function(item, key) {
                    if(item.name === "T0" || item.name === "T1"){
                        tempTerms.push({id: item.id, name: item.name});
                    }
                });
                setListTerms(tempTerms) 
                // Portfolio Managers
                const responsePortfolio = await ListService.getPortfolioManagersList()
                setListPortfolio(responsePortfolio.data)   
                // Currency Exchange Types
                const responseCurrencies = await ListService.getCurrencyExchengeTypesList()
                setListOpeType(responseCurrencies.data)   
            } catch (e) {
                if (axios.isAxiosError(e)) {
                    const statusCode = e.response?.status
                    const error = e.response?.data.errors;
                    
                    if(statusCode && statusCode !== 401){
                        Swal.fire({
                            title: 'ERROR',
                            text: error[0].detail,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#f13939'
                        })
                    }else{
                        sessionStorage.removeItem("userProfile");
                        navigate('/')
                        window.location.reload();
                    }
                }
            } finally{
                setCargando(false)
            }
            
        },[]
    )

    const selectComitente = async (obj) => {
        if(obj !== null){
            if(obj.portfolio_manager_id !== null){
                setPreviewModel({
                    ...previewModel,
                    comitente: obj,
                    codComitente: obj.account,
                    comitenteDesc: obj.name,
                    // accountManager: obj.portfolio_manager,
                    accountManager: obj.portfolio_manager_relation.name,
                    is_internal: obj.is_internal,
                })
            }else{
                Swal.fire({
                    title: 'ERROR',
                    text: "El comitente no tiene un el comercial asignado correctamente.",
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }
       }else{
            setPreviewModel({
                ...previewModel,
                comitente: "",
                codComitente: "",
                comitenteDesc: "",
                accountManager: "",
                is_internal: false,
            })
       }   
    }

    function Contraparte({ valor }) {
        if (valor !== null) {
            return <Typography level="title-sm">{valor.name}</Typography>
        }else{
            return <Typography level="title-sm"></Typography>
        }
    }

    function OperationType({ valor }) {
        if (valor !== null) {
            return <Typography level="title-sm">{valor.name}</Typography>
        }else{
            return <Typography level="title-sm"></Typography>
        }
    }

    const validateForm = function(){
        let rta = true;
        if(previewModel.codComitente === '' || previewModel.codComitente === undefined  || previewModel.codComitente === null){ return false; } 
        if(previewModel.segment === '' || previewModel.segment === undefined  || previewModel.segment === null){ return false; } 
        if(previewModel.term === '' || previewModel.term === undefined  || previewModel.term === null){ return false; } 
        if(previewModel.contraparte === '' || previewModel.contraparte === undefined  || previewModel.contraparte === null){ return false; } 
        if(previewModel.quantity === '' || previewModel.quantity === undefined  || previewModel.quantity === null){ return false; } 
        if(previewModel.base === '' || previewModel.base === undefined  || previewModel.base === null){ return false; } 
        if(previewModel.esco === '' || previewModel.esco === undefined  || previewModel.esco === null){ return false; } 
        if(previewModel.operationType === '' || previewModel.operationType === undefined  || previewModel.operationType === null){ return false; } 
        if(previewModel.is_internal === true){ 
            // CANJES
            if(previewModel.operationType.id === 6 || previewModel.operationType.id === 5){ return false; }
        }
        return rta;
    }

    const validateFormAlerts = function(){
        if(previewModel.is_internal){
            if(previewModel.contraparte.id === previewModel.comitente.portfolio_manager_id){ 
                Swal.fire({
                    title: 'ERROR',
                    text: "El comitene es de uso interno, por lo tanto el oficial de cuenta no puede ser la misma contraparte.",
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else if(previewModel.base !== previewModel.esco){
                Swal.fire({
                    title: 'ERROR',
                    text: "El comitene es de uso interno, el precio base no puede ser diferente al precio ESCO.",
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{return true;} 
        }else{return true;}
    }

    const doOperation = function(){
        try {  
            setCargando(true)
            if(validateFormAlerts()){
                if(validateForm()){
                    Swal.fire({
                        title: "Atención!",
                        text: "Ud. esta seguro que quiere crear la operación ?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Crear",
                        confirmButtonColor: "#83766d"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            let model = {
                                exchange_type_id: 1,
                                settlement_term_id: previewModel.term.id,
                                account: previewModel.comitente.account,
                                segment_id: previewModel.segment.id,
                                price: previewModel.base,
                                qty: previewModel.quantity ,
                                esco_price: previewModel.esco,
                                observations: previewModel.observations,
                                counterparty_id: previewModel.contraparte.id,
                                currency_exchange_type_id: previewModel.operationType.id,
                                is_usd_for_intermediation: previewModel.is_usd_for_intermediation,
                            }

                            ExchangeOperationService.setOperations(model)
                                .then((response) => {
                                    toast.success('Operación creada!', {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    })
                                    // setPreviewModel(initPreview)
                                    window.location.reload();
                                })
                                .catch((error) => {
                                    if(error.response.status !== 401){
                                        Swal.fire({
                                            title: 'Ooops?',
                                            text: error.response.data.errors[0].detail,
                                            icon: 'error',
                                            confirmButtonText: 'OK',
                                            confirmButtonColor: '#f13939'
                                        })
                                    }else{
                                        sessionStorage.removeItem("userProfile");
                                        navigate('/')
                                        window.location.reload();
                                    }
                                })
                                .finally(() => { setCargando(false) })
                        } 
                    });
                }else{
                    Swal.fire({
                        title: 'Ooops?',
                        text: 'Debe completar los datos correctamente!',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }
            }
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        } finally{ setCargando(false) }
    }

    const trgOperationType = function(obj){
        if(obj !== null){
            if(obj.id === 5 || obj.id === 6){
                setPreviewModel({...previewModel,
                    operationType: obj,
                    contraparte: {id: 1, name: "MERCADO"}
                })
            }else{
                setPreviewModel({...previewModel,
                    operationType: obj,
                    contraparte: {id: '',name: "" }
                })
            }
        }
    }

    if(cargando){  return( <Loading></Loading> ) }

    return(
        <div className="row">
            <div className="col-sm-8" style={{paddingLeft: 0}}>
                <div className="card">
                    <div className="card-body" style={{paddingBottom:0}}>
                        <h6 className="card-subtitle text-muted">Operaciones de intermediación con moneda</h6>
                    </div>
                    
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" sx={{ paddingRight: 3 }}>
                        <FormControl>
                            <Checkbox size="md" color="neutral" checked={previewModel.is_usd_for_intermediation} 
                                onChange={(event) => { setPreviewModel({...previewModel, is_usd_for_intermediation: event.target.checked}) }}
                                label={<Typography variant="label" className="MuiFormLabel-root form-labels css-1ckvkg0-JoyFormLabel-root">DÓLARES PARA INTERMEDIACIÓN DE INSTRUMENTO</Typography>}
                            /> 
                        </FormControl>
                    </Grid>

                    <Grid className="card-body" container spacing={2} sx={{ flexGrow: 1 }}>        
                        
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente <span style={{color:'red'}}>*</span></FormLabel>
                                <Autocomplete 
                                    autoFocus
                                    options={listAccounts} 
                                    getOptionLabel={option => option.name +' - '+ option.account }
                                    slotProps={{
                                        listbox: {
                                            sx: (theme) => ({
                                            zIndex: theme.vars.zIndex.modal
                                            })
                                        }
                                    }}
                                    placeholder="Seleccione un Comitente" 
                                    onChange={(event, newValue) => { selectComitente(newValue); }}
                                />  
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Oficial de Cuenta <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="text" size="md" placeholder="" disabled={true} value={previewModel.accountManager}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Tipo <span style={{color:'red'}}>*</span></FormLabel>
                                <Select 
                                    value={previewModel.operationType}
                                    onChange={(event, newValue) => { trgOperationType(newValue) }}
                                >
                                    {listOpeType.map( (currency) => 
                                        <Option value={currency} key={currency.id}>{currency.name}</Option>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Segmento <span style={{color:'red'}}>*</span></FormLabel>
                                <Select 
                                    value={previewModel.segment}
                                    placeholder="" 
                                    onChange={(event, newValue) => { setPreviewModel({...previewModel, segment: newValue}) }}
                                >
                                    {listSegments.map( (segment) => 
                                        <Option value={segment} key={segment.id}>{segment.name}</Option>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Plazo de Liquidacion <span style={{color:'red'}}>*</span></FormLabel>
                                <Select 
                                    value={previewModel.term}
                                    placeholder="" 
                                    onChange={(event, newValue) => setPreviewModel({...previewModel, term: newValue}) }
                                >
                                    {listTerms.map( (term) => 
                                        <Option value={term} key={term.id} label={term.name}>{term.name}</Option>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Contraparte <span style={{color:'red'}}>*</span></FormLabel>
                                {previewModel.operationType.id === 5 || previewModel.operationType.id === 6 ?
                                    <>
                                        <Input type="text" size="md" placeholder="" disabled={true} value={previewModel.contraparte.name}/>
                                    </>
                                :
                                    <Select 
                                        onChange={(event, newValue) => setPreviewModel({...previewModel, contraparte: newValue}) }
                                        value={previewModel.contraparte}
                                    >
                                        {listPorfolio.map( (manager) => 
                                            <Option value={manager} key={manager.id} label={manager.name}>{manager.name}</Option>
                                        )}
                                    </Select>
                                }
                            </FormControl>  
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Cantidad <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="number" size="md" placeholder="" 
                                    value={previewModel.quantity}
                                    slotProps={{
                                        input: {
                                        min: 0,
                                        },
                                    }} 
                                    onChange={(event) => {setPreviewModel({...previewModel, quantity: event.target.value}); }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Precio Base <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="number" size="md" placeholder="" 
                                    value={previewModel.base}
                                    slotProps={{
                                        input: {
                                        min: 0,
                                        },
                                    }} 
                                    onChange={(event) => {setPreviewModel({...previewModel, base: event.target.value});}}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Precio ESCO <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="number" size="md" placeholder="" 
                                    value={previewModel.esco}
                                    slotProps={{
                                        input: {
                                        min: 0,
                                        },
                                    }} 
                                    onChange={(event) => {setPreviewModel({...previewModel, esco: event.target.value}); }}
                                />
                            </FormControl>
                        </Grid>
                    
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Observciones</FormLabel>
                                <Textarea
                                    onChange={(event) => { setPreviewModel({...previewModel, observations: event.target.value}) }}
                                    placeholder="Escriba aqui..."
                                    minRows={4}
                                    maxRows={4}
                                    // value={previewModel.observations}
                                />
                            </FormControl>
                        </Grid>

                        <Typography level="body-xs" style={{color:'red'}}>* obligatorios</Typography>
                    </Grid>
                </div>
            </div>
            <div className="col-sm-4">
                <div className="card">
                    <div className="card-body" style={{paddingBottom:0}}>
                        <h6 style={{color:'red'}} className="card-subtitle text-muted">Vista Previa</h6>
                    </div>

                    <Grid className="card-body" container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={12}>
                            <FormLabel className="form-labels">Comitente</FormLabel>  
                            <Typography level="h2" sx={{ fontSize: 'xl', mb: 0.5 }}>{previewModel.codComitente} - {previewModel.comitenteDesc}</Typography>
                            <Divider />
                        </Grid>

                        <Table>
                            <tbody>
                                <tr key="accountmanager">
                                    <td><span className="form-labels">Oficial de Cuenta</span>  </td>
                                    <td><Typography level="title-sm">{previewModel.accountManager}</Typography></td>
                                </tr>
                                <tr key="opereationtype">
                                    <td><span className="form-labels">Tipo</span>  </td>
                                    {/* <td><Typography level="title-sm">{previewModel.opereationtype.name}</Typography></td> */}
                                    <td><OperationType valor={previewModel.operationType}/></td>
                                </tr>
                                <tr key="segmento">
                                    <td><span className="form-labels">Segmento</span>  </td>
                                    <td><Typography level="title-sm">{previewModel.segment.name}</Typography></td>
                                </tr>
                                <tr key="plazo">
                                    <td><span className="form-labels">Plazo de liquidación</span>  </td>
                                    <td><Typography level="title-sm">{previewModel.term.name}</Typography></td>
                                </tr>
                                <tr key="contraparte">
                                    <td><span className="form-labels">Contraparte</span>  </td>
                                    <td><Contraparte valor={previewModel.contraparte}/></td>
                                </tr>
                                <tr key="qty">
                                    <td><span className="form-labels">Cantidad</span>  </td>
                                    <td>
                                        <Typography level="title-sm">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={previewModel.quantity} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator=","
                                            /> 
                                        </Typography>
                                    </td>
                                </tr>
                                <tr key="pbase">
                                    <td><span className="form-labels">Precio Base</span>  </td>
                                    <td>
                                        <Typography level="title-sm">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={previewModel.base} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator=","
                                                prefix={'$'}  
                                            /> 
                                        </Typography>
                                    </td>
                                </tr>
                                <tr key="pesco">
                                    <td><span className="form-labels">Precio ESCO</span>  </td>
                                    <td>
                                        <Typography level="title-sm">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={previewModel.esco} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator=","
                                                prefix={'$'}  
                                            /> 
                                        </Typography>
                                    </td>
                                </tr>
                                <tr key="spread">
                                    <td><span className="form-labels">Ganancia</span>  </td>
                                    <td>
                                        {previewModel.operationType.id === 1 || previewModel.operationType.id === 3 || previewModel.operationType.id === 5 ?
                                            (
                                                <span>
                                                    <Typography level="title-sm">
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={previewModel.esco - previewModel.base} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                        /> 
                                                    </Typography>
                                                    <FormHelperText><small>(Precio ESCO - Precio Base)</small></FormHelperText>
                                                </span>
                                            )
                                        :
                                            (
                                                <span>
                                                    <Typography level="title-sm">
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={previewModel.base - previewModel.esco} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                        /> 
                                                    </Typography>
                                                    <FormHelperText><small>(Precio Base - Precio ESCO)</small></FormHelperText>
                                                </span>
                                            )
                                            
                                        }
                                    </td>
                                </tr>
                                <tr key="total">
                                    <td><span className="form-labels">Ganancia Total</span>  </td>
                                    <td>
                                        {(previewModel.operationType.id === 1 || previewModel.operationType.id === 3) &&
                                            ( <Typography level="title-sm">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={(previewModel.esco - previewModel.base) * previewModel.quantity} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator=","
                                                    prefix={'$'}  
                                                /> 
                                            </Typography>)
                                        }
                                        {(previewModel.operationType.id === 2 || previewModel.operationType.id === 4) &&
                                            (
                                                <Typography level="title-sm">
                                                    <NumericFormat 
                                                        displayType="text" 
                                                        value={(previewModel.base - previewModel.esco) * previewModel.quantity} 
                                                        allowLeadingZeros thousandSeparator="." 
                                                        decimalSeparator=","
                                                        prefix={'$'}  
                                                    /> 
                                                </Typography>
                                            )
                                        }
                                        {(previewModel.operationType.id === 5) &&
                                        (
                                            <Typography level="title-sm">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={((previewModel.esco - previewModel.base) * previewModel.quantity)/100} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator=","
                                                    prefix={'$'}  
                                                /> 
                                            </Typography>
                                        )
                                        }
                                        {(previewModel.operationType.id === 6) &&
                                        (
                                            <Typography level="title-sm">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={((previewModel.base - previewModel.esco) * previewModel.quantity)/100} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator=","
                                                    prefix={'$'}  
                                                /> 
                                            </Typography>
                                        )
                                        }
                                    </td>
                                </tr>      
                                {(previewModel.operationType.id === 5 || previewModel.operationType.id === 6 )&&        
                                    <tr key="cantidadFinal">
                                        <td><span className="form-labels">Cantidad Final</span>  </td>
                                        <td>
                                            {previewModel.operationType.id === 5 ?
                                                (
                                                    <Typography level="title-sm">
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={ previewModel.quantity - previewModel.quantity * (previewModel.esco / 100)} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                        /> 
                                                    </Typography>
                                                )
                                            :
                                                (
                                                    <Typography level="title-sm">
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={ parseFloat(previewModel.quantity) + parseFloat(previewModel.quantity * (previewModel.esco / 100 ))} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                        /> 
                                                    </Typography>
                                                )
                                            }
                                            
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                        <Grid xs={12}>
                            <button type="button" className="btn btn-info d-grid w-100" onClick={doOperation}>CREAR OPERACION</button>
                        </Grid>
                        
                        
                    </Grid>
                </div>
            </div>
        </div>

    );


}

export default OperationsMoney;